const EMPTY_LABEL = '--';
export default EMPTY_LABEL;